export function initGTM() {
  if (typeof window === "undefined") return;
  if (window.__dvlzGtmInit) return; // idempotente: evita scripts/page_views duplicados (StrictMode, remounts)
  window.__dvlzGtmInit = true;
  const id = process.env.REACT_APP_GTM_ID;
  window.dataLayer = window.dataLayer || [];
  if (id) {
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(s);
  }
  const ga = process.env.REACT_APP_GA_ID;
  if (ga) {
    const g = document.createElement("script");
    g.async = true;
    g.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
    document.head.appendChild(g);
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ga);
  }
  // Google Ads (AW): reutiliza el MISMO gtag.js ya cargado — no se agrega
  // ningún script duplicado, solo se registra el destino AW con config.
  const aw = process.env.REACT_APP_AW_ID;
  if (aw) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", aw);
  }
}

// Conversión Google Ads "Solicitud de presupuesto".
// Llamar SOLO tras confirmación de éxito real del endpoint del formulario.
export function trackAdsConversion() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const sendTo = process.env.REACT_APP_AW_CONVERSION;
  if (!sendTo) return;
  window.gtag("event", "conversion", {
    send_to: sendTo,
    value: 1.0,
    currency: "CLP",
  });
}

export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, page_path: window.location.pathname, ...params });
}
